import { Flex, FlexProps } from '@mantine/core';

export type IFlexProps = FlexProps;

export function ZorroFlex({ ...props }: IFlexProps) {
  return <Flex {...props} />;
}
